import { Cancel } from '@mui/icons-material';
import {
  Box,
  Chip,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { EndPoints } from '../../../common/enums/enums';
import { amplifyApi } from '../../../hooks/amplifyApi';
import { selectCompanyId } from '../../../redux/selectors/userDataSelectors';

const ServicesFilter = ({ filtersSx, selectedFilters, setSelectedFilters }) => {
  const { t } = useTranslation('bulk');
  const userCompanyId = useSelector(selectCompanyId);
  const [services, setServices] = useState(null);

  useEffect(() => {
    amplifyApi(
      null,
      EndPoints.BULK_EXPORT.BULK_SERVICES.ENDPOINT.replace(
        '{companyId}',
        userCompanyId
      ),
      EndPoints.BULK_EXPORT.BULK_SERVICES.TYPE,
      true
    )
      .then(response => {
        setServices(response.data.services);
      })
      .catch(error => {
        setServices(null);
      });
  }, [userCompanyId]);

  const handleSelectedServices = e => {
    if (e.target.value.includes('all')) {
      setSelectedFilters(state => ({
        ...state,
        selectedServices: {
          services,
          allSelected: true,
        },
      }));
    } else {
      setSelectedFilters(state => ({
        ...state,
        selectedServices: {
          services: e.target.value,
          allSelected: false,
        },
      }));
    }
  };
  return services ? (
    <FormControl size="small" sx={filtersSx}>
      <InputLabel>{t('service')}</InputLabel>
      <Select
        label={t('service')}
        value={selectedFilters.selectedServices.services}
        onChange={handleSelectedServices}
        multiple
        SelectDisplayProps={{
          'data-testid': 'servicesFilter',
        }}
        inputProps={{
          'data-testid': 'servicesFilterInput',
        }}
        MenuProps={{
          sx: { maxHeight: '200px' },
        }}
        renderValue={() => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selectedFilters.selectedServices.allSelected ? (
              <Typography>{t('allOption')}</Typography>
            ) : (
              <Chip
                size="small"
                onDelete={() =>
                  setSelectedFilters(state => ({
                    ...state,
                    selectedServices: {
                      services: [],
                      allSelected: false,
                    },
                  }))
                }
                deleteIcon={
                  <Cancel onMouseDown={event => event.stopPropagation()} />
                }
                label={`${selectedFilters.selectedServices.services.length} ${t(
                  'servicesChip'
                )}`}
              />
            )}
          </Box>
        )}
      >
        <MenuItem value="all">{t('allOption')}</MenuItem>
        <Divider />
        {services.map((s, i) => (
          <MenuItem key={s + i} value={s}>
            {s}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  ) : (
    <Skeleton variant="rounded" width={filtersSx.flexBasis} height={40} />
  );
};

export default ServicesFilter;
